// @mui
import { Box, Typography, Grid } from "@material-ui/core";

import Iconify from "../Iconify";

// ----------------------------------------------------------------------

export default function FileBlockContent({
  file,
  title,
  subtitle,
  iconSelect = null,
}) {
  const preview = file ? URL.createObjectURL(file) : "";

  return (
    <Grid
      spacing={2}
      style={{
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        margin: 0,
        padding: 0,
      }}
    >
      <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
        <Box
          width={"450px"}
          height={"200px"}
          margin={"auto"}
          borderRadius="10%"
          style={{ padding: 5 }}
          border={"1px dashed rgba(145, 158, 171, 0.32)"}
        >
          <Box
            className="placeholder"
            style={{
              Zindex: 0,
              width: "100%",
              height: "100%",
              outline: "none",
              overflow: "hidden",
              flexDirection: "column",
              position: "relative",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "10%",
              color: "#637381",
              backgroundColor: "#F4F6F8",
              "&:hover": { opacity: 0.72 },
              display: "flex",
            }}
          >
            {file ? (
              <>
                {(file?.type === "image/jpeg" || file?.type === "image/png") &&
                preview !== "" ? (
                  <img
                    src={preview}
                    alt="preview"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "300px",
                      maxWidth: "180px",
                      borderRadius: 25,
                    }}
                  />
                ) : file?.type === "application/pdf" ? (
                  <Iconify
                    icon="hugeicons:pdf-02"
                    style={{
                      width: 45,
                      height: 45,
                      marginBottom: 2,
                      color: "#B30B00",
                    }}
                  />
                ) : (
                  <Iconify
                    icon="solar:document-add-broken"
                    style={{ width: 45, height: 45, marginBottom: 2 }}
                  />
                )}
                <Typography variant="body1" style={{ marginTop: 10 }}>
                  {file?.name || "Document Accepted"}
                </Typography>
              </>
            ) : (
              <>
                <Iconify
                  icon={iconSelect || "solar:document-broken"}
                  style={{ width: 45, height: 45, marginBottom: 2 }}
                />
                <Typography variant="body1" style={{ marginTop: 10 }}>
                  Upload Document
                </Typography>
              </>
            )}
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 3 }}>
        <Box style={{ padding: 1 }}>
          {title && title}
          {subtitle && subtitle}
        </Box>
      </Grid>
    </Grid>
  );
}
